import React, { FC, useCallback, useMemo, useState } from 'react';
import { Button } from 'src/common';
import styles from './index.module.scss';
import { useTranslation } from 'react-i18next';
import { useSetBidQuestionAnswer, useTask } from 'src/models/bids/BidTask/hooks';
import TextResponseAttachment from 'src/shared/Bid/BidFiles/TextResponseAttachment';
import TextResponseModal from 'src/shared/Bid/BidFiles/TextResponseModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-light-svg-icons';
import { trackBTUploadFile } from 'src/segment/events';

export const FilesAnswer: FC = () => {
  const { t } = useTranslation();

  // fixme a bit tricky
  const [deletedFileId, setDeletedFileId] = useState<string | undefined>(undefined);

  const [docsLibraryVisible, setDocsLibraryVisible] = useState(false);
  const onDocsLibraryOpen = useCallback(() => {
    setDocsLibraryVisible(true);
  }, []);
  const onDocsLibraryClose = useCallback(() => {
    setDocsLibraryVisible(false);
  }, []);

  const [setAnswer, { loading: isAttachLoading }] = useSetBidQuestionAnswer();
  const { data: task } = useTask();
  const files = useMemo(() => {
    return task?.answer?.files ? task.answer.files : [];
  }, [task]);

  const onAttach = useCallback(
    (fileId: string) => {
      if (!task) return;
      const filteredFiles = [...files.map(file => file.id), fileId];
      setAnswer(
        {
          questionId: task.id,
          questionGroupId: task.groupId,
          answer: {
            files: filteredFiles
          }
        },
        () => setDocsLibraryVisible(false)
      );
      trackBTUploadFile(task.id, task.groupId, task.bidId, task.type);
    },
    [files, task, setAnswer]
  );

  const onDeleteFile = useCallback(
    (fileId: string) => {
      if (!task) return;
      setDeletedFileId(fileId);
      const filteredFiles = files.filter(file => file.id !== fileId).map(file => file.id);
      setAnswer(
        {
          questionId: task.id,
          questionGroupId: task.groupId,
          answer: {
            files: filteredFiles
          }
        },
        () => setDeletedFileId(undefined)
      );
    },
    [files, task, setAnswer]
  );

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        {!!files.length && (
          <ul className={styles.files}>
            {files.map(file => (
              <TextResponseAttachment
                file={file}
                key={file.id}
                onDeleteFile={onDeleteFile}
                isLoading={deletedFileId === file.id}
                procurementId={task?.originId}
              />
            ))}
          </ul>
        )}
        <Button
          className={styles.addFiles}
          type={'link'}
          onClick={onDocsLibraryOpen}
          icon={<FontAwesomeIcon icon={faPlus} />}
        >
          {t('BiddingTool.addFilesFromDocumentLibrary')}
        </Button>

        {docsLibraryVisible && (
          <TextResponseModal
            onClose={onDocsLibraryClose}
            onAttach={onAttach}
            files={files}
            isLoading={isAttachLoading}
          />
        )}
      </div>
    </div>
  );
};

export default FilesAnswer;
